/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { CSSProperties } from 'react'
import styled, { Interpolation } from 'styled-components'
import { useThemeContext } from '../../../contexts/ThemeContext'
import FlexBox from '../../Common/FlexBox'
import Spinner from '../../Common/Spinner'

type Props = {
  style?: Interpolation<CSSProperties>
}

const Loading = ({ style }: Props) => {
  const { colors } = useThemeContext()

  return (
    <StyledFlex justifyContent="center" alignItems="center" style={style}>
      <Spinner size={48} stroke={colors.primary} />
    </StyledFlex>
  )
}

export default Loading

const StyledFlex = styled(FlexBox)<Pick<Props, 'style'>>`
  padding-bottom: 3.6455vw;

  ${({ style }) => style}
`
